import type { AxiosError } from 'axios';

/** Axios's public error marker, without loading its HTTP adapters to inspect an error. */
export function isQuantaHttpError<T = unknown>(error: unknown): error is AxiosError<T> {
  return typeof error === 'object' && error !== null && 'isAxiosError' in error && error.isAxiosError === true;
}
